import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  EventEmitter,
  HostBinding,
  Output,
} from '@angular/core';

@Directive({
    selector: '[luiContextMenuItem]',
    standalone: false
})
export class ContextMenuItemDirective {
  @HostBinding('class') className = 'lui-context-menu-item';
}

@Component({
    selector: 'lui-context-menu',
    templateUrl: './context-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContextMenuComponent {
  @HostBinding('class') className = 'lui-context-menu';

  @Output() hovered = new EventEmitter<boolean>();
}
